<template>
  <div>
    <el-dialog title="导航设置" :visible.sync="menuVisible" width="800px">
      <el-row type="flex" justify="space-between" class="mb15">
        <el-col :span="1"> </el-col>
        <el-col :span="3">
          <el-button
            v-auth="'/onlineSchool/addMenu'"
            type="primary"
            class="mb15"
            @click="
              popType = '新增';
              dialogVisible = true;
              ruleForm.title = '';
              ruleForm.linkUrl = '';
              ruleForm.sort = 0;
            "
            >新增导航</el-button
          >
        </el-col>
      </el-row>

      <el-table
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        class="menuTable"
        tooltip-effect="dark"
        :data="menuList"
        border
        style="width: 100%; margin-top: 20px"
      >
        <el-table-column prop="title" label="导航名称"></el-table-column>
        <el-table-column prop="linkUrl" label="链接地址"></el-table-column>
        <el-table-column prop="sort" label="排序"></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="enabled"
          label="状态"
          align="center"
        >
          <template slot-scope="scope">
            <el-switch
              v-if="scope.row.foreverExist != 1"
              v-model="scope.row.enabled"
              :active-value="1"
              :inactive-value="-1"
              @change="updateSwitching(scope.row)"
              class="switchStyle"
            ></el-switch>
            <div v-else>展示</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-link
              type="primary"
              :underline="false"
              @click="editMenu(scope.row)"
            >
              编辑
            </el-link>
            <el-popconfirm
              icon="el-icon-info"
              icon-color="red"
              title="确定删除这条数据吗？"
              @confirm="deleteSure(scope.row)"
            >
              <el-link type="primary" :underline="false" slot="reference"
                >删除</el-link
              >
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!--新增编辑弹框-->
    <el-dialog :title="popType" :visible.sync="dialogVisible" width="40%">
      <el-form
        :model="ruleForm"
        :rules="rules"
        style="width: 70%"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="导航类型">
          <el-radio-group v-model="ruleForm.type">
            <el-radio :label="1">路由</el-radio>
            <el-radio :label="2">外链接地址</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="导航名称" prop="title">
          <el-input v-model="ruleForm.title"></el-input>
        </el-form-item>
        <el-form-item label="链接地址" prop="linkUrl">
          <el-input v-model="ruleForm.linkUrl"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="ruleForm.sort" type="number"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addUrlSure('ruleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      menuVisible: false,
      ids: [],
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
      },
      menuList: [],
      loading: false,
      dialogVisible: false,
      popType: "",
      ruleForm: {
        type: 1,
        linkUrl: "",
        title: "",
        sort: 0,
        name: "",
        id: "",
        schoolPageTemplateId: "",
      },
      rules: {
        title: [{ required: true, message: "请输入导航名称", trigger: "blur" }],
        linkUrl: [
          { required: true, message: "请输入链接地址", trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    menuVisible(val) {
      if (val) {
        this.pageList();
      } else {
        this.$store.dispatch("design/getMenu");
      }
    },
  },
  methods: {
    pageList() {
      this.api.wxSchoolPageMenu
        .getWxSchoolPageMenuList({
          schoolPageTemplateId: this.ruleForm.schoolPageTemplateId,
        })
        .then((result) => {
          this.menuList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    editMenu(row) {
      this.ruleForm.id = row.id;
      this.popType = "编辑";
      this.dialogVisible = true;
      this.api.wxSchoolPageMenu
        .getWxSchoolPageMenu({
          id: row.id,
        })
        .then((result) => {
          this.ruleForm = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addUrlSure(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //新增or编辑
          if (this.popType == "新增") {
            this.api.wxSchoolPageMenu
              .addWxSchoolPageMenu(this.ruleForm)
              .then((result) => {
                this.dialogVisible = false;
                this.pageList();
              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            this.api.wxSchoolPageMenu
              .updateWxSchoolPageMenu(this.ruleForm)
              .then((result) => {
                this.dialogVisible = false;
                this.pageList();
              })
              .catch((error) => {
                console.log(error);
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    deleteSure(row) {
      this.api.wxSchoolPageMenu
        .deleteWxSchoolPageMenu([{ id: row.id }])
        .then((result) => {
          if (result.success) {
            this.$message({
              type: "success",
              message: result.message,
            });
            this.pageList();
          } else {
            this.$message({
              type: "error",
              message: result.message,
            });
            this.pageList();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    updateSwitching(row) {
      this.api.wxSchoolPageMenu
        .enabled({
          id: row.id,
          enabled: row.enabled,
        })
        .then((result) => {
          if (result.success) {
            this.$message({
              type: "success",
              message: result.message,
            });
            this.pageList();
          } else {
            this.$message({
              type: "error",
              message: result.message,
            });
            this.pageList();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.ruleForm.schoolPageTemplateId = this.$route.query.id;
  },
};
</script>


// WEBPACK FOOTER //
// src/components/designPage/components/menuDialog.vue